import { combineReducers } from "redux";
import report from "./report";
import contact from "./contact";
import fleet from "./fleet";
import auth from "./auth";
import order from "./order";
import staff from "./staff";
import customers from "./customers";
import manageservice from "./services";
import Memberships from "./Memberships";
import Notification from "./notification";
import Stripe from "./stripe";
import checklists from "./checklists";
import vehicles from "./vehicle";
import rentVehicle from "./rentVehicle";
import additionalprice from "./additionalprice";
import affiliate from "./affiliate";

const rootReducer = combineReducers({
  auth,
  order,
  report,
  contact,
  staff,
  fleet,
  customers,
  Memberships,
  manageservice,
  Notification,
  Stripe,
  checklists,
  vehicles,
  rentVehicle,
  additionalprice,
  affiliate,
});
export default rootReducer;
